import CloseIcon from "@mui/icons-material/Close";

const Close = (props: any) => {
  return <CloseIcon {...props} />;
};

export default Close;
